import React, { useContext } from 'react';
import Switch from 'react-switch';
import { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';
import { ContainerAbout, Image, SubContainerAbout, SubTitle, Description, ContainerButtons, ContactButton, TextButton } from './styles';

import photo from '../../assets/photo.png';

import { FiArrowRight } from "react-icons/fi";
interface Props {
    toggleTheme(): void;
}

const About: React.FC<Props> = ({ toggleTheme }) => {
    const { colors, title } = useContext(ThemeContext);

    return (
        <ContainerAbout id="sobre">
            <Image src={photo} alt="Everton Santana" />

            <SubContainerAbout>
                <SubTitle>
                    Sobre mim
                </SubTitle>

                <Description>
                    Olá! Sou um desenvolvedor fullstack dedicado, focado em criar soluções inovadoras e eficientes.  
                </Description>

                <Description>
                    Domino linguagens fundamentais como HTML, CSS, JavaScript e TypeScript, além de trabalhar com tecnologias modernas para desenvolvimento front-end, como ReactJS, Next.js, Angular, Sass e Bootstrap, garantindo interfaces atrativas e funcionais.  
                </Description>

                <Description>
                    No back-end, utilizo Node.js, Laravel e Spring Boot, integrando ferramentas como Prisma para manipulação de dados de forma eficaz. Tenho conhecimentos sólidos em bancos de dados como MySQL e PostgreSQL, aplicando boas práticas em organização e estruturação dos dados nos meus projetos.  
                </Description>

                <Description>
                    Minha experiência inclui também o uso de linguagens como Python e Java, permitindo-me atuar em diferentes contextos do desenvolvimento de software.  
                </Description>

                <Description>
                    Valorizo uma arquitetura de software bem organizada e mantenho um foco constante em escrever código limpo e bem documentado. Para isso, utilizo ferramentas como Git, GitHub, Figma e Insomnia, que otimizam a gestão e o desenvolvimento dos meus projetos.  
                </Description>

                <Description>
                    Estou sempre em busca de desafios que me permitam aplicar meus conhecimentos e expandir minhas habilidades, entregando soluções que unem inovação e qualidade.  
                </Description>
                <ContainerButtons>
                    <ContactButton href="#contato">
                        <TextButton>
                            Contato
                        </TextButton>
                    </ContactButton>
                </ContainerButtons>
            </SubContainerAbout>
        </ContainerAbout>
    );
}

export default About;